















export var AlignmentTypes;(function (AlignmentTypes) {AlignmentTypes["LEFT_START"] = "leftStart";AlignmentTypes["LEFT_CENTER"] = "leftCenter";AlignmentTypes["LEFT_END"] = "leftEnd";AlignmentTypes["TOP_START"] = "topStart";AlignmentTypes["TOP_CENTER"] = "topCenter";AlignmentTypes["TOP_END"] = "topEnd";AlignmentTypes["RIGHT_START"] = "rightStart";AlignmentTypes["RIGHT_CENTER"] = "rightCenter";AlignmentTypes["RIGHT_END"] = "rightEnd";AlignmentTypes["BOTTOM_START"] = "bottomStart";AlignmentTypes["BOTTOM_CENTER"] = "bottomCenter";AlignmentTypes["BOTTOM_END"] = "bottomEnd";})(AlignmentTypes || (AlignmentTypes = {}));
//# sourceMappingURL=Tooltip.js.map